import { render } from "./PlaceHolder.vue?vue&type=template&id=a8c5e7dc&ts=true&lang=pug"
import script from "./PlaceHolder.vue?vue&type=script&lang=ts"
export * from "./PlaceHolder.vue?vue&type=script&lang=ts"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__